import React from "react";
import { ColumnsType } from "antd/es/table";
import { TFunction } from "i18next";
import { getFormatDate } from "~/libs/getFormatDate";

export const getEditorPhotoGalleryColumns = (
  t: TFunction,
  options: string[]
): ColumnsType<any> =>
  options.map((option) => {
    const baseColumn = {
      title: t(`photoGallery.table.${option}`),
      dataIndex: option,
      key: option,
    };

    // Special render for createdAt field - format date
    if (option === "createdAt") {
      return {
        ...baseColumn,
        render: (value: any) => <span>{getFormatDate(value)}</span>,
      };
    }

    return {
      ...baseColumn,
      render: (value: any) => <span>{value}</span>,
    };
  });
